import { ofType, StateObservable } from 'redux-observable';
import { Observable } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';
import type { Action } from '@reduxjs/toolkit';

import { REQUEST_SIZE_INTERNAL_SHARED_USERS } from '../../components/SocialButtons/Share/InternalShare/constants/share';

import { gqlRequest } from '../../helpers/request';
import * as iShareSelectors from '../selectors/guestShare';
import { getInvitationListAction, setInvitationListAction } from '../slices/guestShare';

const queryGQL = `
  query hostedWatchGetInvitationList(
    $page: Int,
    $pageSize: Int,
    $sortBy: String,
    $sortOrder: String,
    $videoId: String!,
  ) {
    hostedWatchGetInvitationList(
      page: $page,
      pageSize: $pageSize,
      sortBy: $sortBy,
      sortOrder: $sortOrder,
      videoId: $videoId,
    ) {
      recordsTotal
      page
      pageSize
      records {
        id
        email,
        invStatus
      }
    }
  }
`;

type GetInvitationListActionPayload = {
  payload: {
    videoId: string;
    isAddRequest: boolean;
  };
};

type HostedWatchGetInvitationListType = {
  recordsTotal: number;
  page: number;
  records: Array<{
    id: string;
    email: string;
    invStatus: string;
  }>;
};

export default (action$: Observable<Action>, state$: unknown) =>
  action$.pipe(
    ofType(getInvitationListAction.type),
    mergeMap(({ payload: { videoId, isAddRequest } }: GetInvitationListActionPayload) => {
      const state$$ = state$ as StateObservable<RootState>;

      const invitationList = iShareSelectors.invitationList(state$$.value);

      const indexPage = isAddRequest ? Math.floor(invitationList.length / REQUEST_SIZE_INTERNAL_SHARED_USERS) : 0;

      return gqlRequest({
        query: queryGQL,
        variables: {
          page: indexPage + 1,
          pageSize: REQUEST_SIZE_INTERNAL_SHARED_USERS,
          sortBy: 'invStatus',
          sortOrder: 'asc',
          videoId,
        },
      }).pipe(
        map(({ data, errors }) => {
          const payload = {
            totalCount: 0,
            page: 1,
            invitationList,
          };

          if (!errors?.length) {
            const { recordsTotal, page, records } =
              data.hostedWatchGetInvitationList as HostedWatchGetInvitationListType;

            payload.totalCount = recordsTotal;
            payload.page = page;

            const formattedInvitationList = records.map((record) => ({
              invitationId: record.id,
              email: record.email,
              state: record.invStatus.toUpperCase(),
            }));

            payload.invitationList = isAddRequest
              ? invitationList.concat(formattedInvitationList)
              : formattedInvitationList;
          }

          return setInvitationListAction(payload);
        }),
      );
    }),
  );
